import { useMutation, UseMutationResult } from '@tanstack/react-query';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';
import { HTTP_METHOD } from '@dealstack/shared/lib/common/dataExchange/common';
import { makeRequest } from '@dealstack/frontend/shared/dataExchange/ApiLayer/apiLayer';
import { formatUnicorn } from '@dealstack/shared/lib/format/formatUnicorn';
import * as ApiV1 from '@dealstack/shared/lib/common/dataExchange/apiV1';
import { ProgrammeUserWithPermissionsRes } from '@dealstack/shared/lib/generated';
import { ServiceRequestOptions } from '@dealstack/frontend/shared/other/react/ApiWrapper/types';

const deleteProgrammeUser = async ({
	userId,
	programmeId,
	options,
}: {
	userId: string;
	programmeId: string;
	options?: ServiceRequestOptions;
}) => {
	const response = await makeRequest<ApiV1.Response<ProgrammeUserWithPermissionsRes>>(
		{
			endpoint: formatUnicorn(API_PATHS.MIP_PROGRAMMEID_USERS_USERID_DELETE, {
				userId,
				programmeId,
			}),
			method: HTTP_METHOD.DELETE,
		},
		options
	);
	return response;
};

export const useDeleteProgrammeUser = (): UseMutationResult<
	ApiV1.Response<ProgrammeUserWithPermissionsRes>,
	unknown,
	{ programmeId: string; userId: string }
> => {
	return useMutation({
		mutationFn: deleteProgrammeUser,
	});
};
